import { render, staticRenderFns } from "./FoodcourtOrderStatusBoard.vue?vue&type=template&id=470fafcc&scoped=true"
import script from "./FoodcourtOrderStatusBoard.vue?vue&type=script&lang=js"
export * from "./FoodcourtOrderStatusBoard.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtOrderStatusBoard.vue?vue&type=style&index=0&id=470fafcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470fafcc",
  null
  
)

export default component.exports